function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import React from 'react';
import { Link } from 'react-router-dom';
import { Strong } from '@finect/tabular-core/Strong';
import { AppLink } from '@finect/tabular-core/AppLink';
import { ChevronRight } from '@finect/tabular-icons/chevronRight';
import { Tabs, TabsPane } from '../../../../Tabs';
import { Image } from '../../../../Image';
import { ManagerContent } from './ManagerContent';
import { Inner, HeaderBlock, ManagerBlock, FooterBlock, DescriptionBlock, StyledTextContainer, LastContentBlock, OrganizationLogoBlock } from './partials';
export var ManufacturersColumn = function ManufacturersColumn(_ref) {
  var managers = _ref.managers,
    onTabChange = _ref.onTabChange,
    _ref$managersContents = _ref.managersContents,
    managersContents = _ref$managersContents === void 0 ? [] : _ref$managersContents,
    _ref$qty = _ref.qty,
    qty = _ref$qty === void 0 ? 3 : _ref$qty;
  var handleTabChange = function handleTabChange(event) {
    var manufacturer = managers.find(function (_ref2) {
      var tagline = _ref2.tagline;
      return tagline === event.title;
    });
    manufacturer && onTabChange(manufacturer);
  };
  return React.createElement(Inner, null, React.createElement(Tabs, {
    wrap: "nowrap",
    variant: "columns",
    size: "small",
    left: true,
    onChange: handleTabChange
  }, managers.map(function (manager) {
    var contentsContainer = managersContents.filter(function (item) {
      return item.manager === manager.alias;
    }).map(function (_ref3) {
      var items = _ref3.items;
      return items;
    });
    var _contentsContainer = _slicedToArray(contentsContainer, 1),
      _contentsContainer$ = _contentsContainer[0],
      contents = _contentsContainer$ === void 0 ? [] : _contentsContainer$;
    var id = manager.id,
      alias = manager.alias,
      logo = manager.logo,
      displayName = manager.displayName,
      tagline = manager.tagline,
      description = manager.description;
    var linkProps = manager.features.blog ? {
      as: Link,
      to: "/grupos/".concat(alias),
      title: "Ver perfil de ".concat(displayName, " en Finect"),
      'data-fi-event': 'manufacturerLogo'
    } : {
      as: 'span'
    };
    return React.createElement(TabsPane, {
      icon: logo,
      title: tagline,
      key: id
    }, React.createElement(HeaderBlock, null, React.createElement(OrganizationLogoBlock, _extends({}, linkProps, {
      $withBackground: true
    }), React.createElement(Image, {
      height: 144,
      format: "png",
      src: logo,
      alt: "Logo de ".concat(displayName)
    }))), React.createElement(ManagerBlock, null, React.createElement(StyledTextContainer, null, React.createElement(DescriptionBlock, null, description)), contents.length ? React.createElement(LastContentBlock, null, contents.slice(0, qty).map(function (content, index) {
      return React.createElement(ManagerContent, {
        key: index,
        content: _objectSpread({}, content),
        withIcon: false
      });
    })) : null), React.createElement(FooterBlock, null, React.createElement(AppLink, {
      as: Link,
      to: "/grupos/".concat(alias),
      title: "Ver perfil de ".concat(displayName, " en Finect")
    }, React.createElement(Strong, null, "Ver m\xE1s de ", displayName), React.createElement(ChevronRight, {
      size: "18px",
      strokeWidth: "3"
    }))));
  })));
};